import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./icons";
import { SITE, waLink } from "../lib/site";

const FAQS = [
  {
    q: "Can I send my own design?",
    a: "Absolutely — sketches, screenshots, photos, logos, or even a rambling voice note describing the idea. The rougher the better: we redraw it into a tufting-ready design and confirm it with you before any yarn is punched.",
  },
  {
    q: "Can I choose the size, shape, and colours?",
    a: "Yes. Every rug is made to order in your choice of dimensions and shape — rectangle, circle, oval, or a custom silhouette that follows the design. We'll suggest yarn colours from our palette and do our best to match specific shades you have in mind.",
  },
  {
    q: "How is my quote calculated?",
    a: "Each rug is priced on its size, shape complexity, number of colours, and detail work — so there's no fixed rate card. Share your idea and we'll come back with a clear quote for you to approve before anything is confirmed.",
  },
  {
    q: "Can I request a name or word rug?",
    a: "Names, words and phrases are one of our favourite things to tuft. Send the exact spelling and any font style you like, and we'll show you a design draft for approval before making it.",
  },
  {
    q: "How do I discuss a preferred delivery date?",
    a: "Mention your date in the enquiry form or tell us on WhatsApp. We'll confirm honestly what's possible for your design and size before you commit — and we'll never promise a date we can't keep.",
  },
  {
    q: "How should I care for my rug?",
    a: "Every rug comes with care guidance suited to its yarn and backing. As general habits: vacuum gently without a beater bar, spot-clean spills promptly, and keep the rug away from prolonged moisture. Ask us during your enquiry and we'll walk you through the specifics.",
  },
];

export function Faq() {
  return (
    <section id="faqs" className="py-20 sm:py-24" data-testid="faqs">
      <div className="max-w-3xl mx-auto px-5 sm:px-6">
        <Reveal>
          <p className="flex items-center justify-center gap-2 text-xs sm:text-sm uppercase tracking-[0.22em] text-burgundy font-medium">
            <span className="inline-block h-2 w-2 rounded-full bg-brass" aria-hidden="true" />
            FAQs
          </p>
          <h2 className="mt-3 text-center font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-forest">
            Good questions, honest answers.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-brass/30">
                <AccordionTrigger className="text-left font-serif text-lg sm:text-xl text-forest hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base leading-relaxed text-charcoal/75">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 rounded-2xl border border-brass/40 bg-brass-soft p-6 text-center">
            <p className="text-sm sm:text-base text-charcoal/75">
              Something else on your mind? The fastest way to reach the studio is WhatsApp — we can
              talk through sizes, colours and quotes there.
            </p>
            <a
              href={waLink(SITE.waGenericMessage)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-whatsapp-button"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-forest text-ivory text-sm font-medium px-6 py-3 transition-all duration-200 hover:bg-forest-deep hover:-translate-y-0.5"
            >
              <WhatsAppIcon />
              Chat with us on WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
